<template>
    <div class="gap-xs flex cursor-pointer items-center justify-start" @click="toggleOpen">
        <i class="i-chevron-down transition-transform" :class="{ 'rotate-180': open }" />
        <slot name="trigger"></slot>
    </div>
    <div v-if="open" class="dropdown-content">
        <slot name="content"></slot>
    </div>
</template>

<script setup lang="ts">
// TODO: Add animations to dropdown content
import { ref, watch } from 'vue';

const props = defineProps({
    defaultOpen: { type: Boolean, default: false },
});
const open = ref(props.defaultOpen ?? false);

function toggleOpen() {
    open.value = !open.value;
}

watch(
    () => props.defaultOpen,
    (newVal) => {
        open.value = newVal;
    },
);
</script>
